<Title>
  Personalize Your Note
  <span slot="subtitle">
    Add a message and optional photo to your note
  </span>
</Title>
<PhotoInput />
<div class="ne-text-controls">
  <span class="ne-control">
    Fonts
    <div
      class="ne-control-action ne-font-control"
      style="font-size: {fontSize}px; font-family: {fontFamily}; font-weight: {fontWeight}; color: {$store.textColor.hex.state}"
      data-heap-font-control="{fontFamily}"
      data-test-font-control="{fontFamily}"
      on:click="{toggleFontModal}">
      <span>{getDisplayName(fontFamily)}</span>
      <span class="ne-down-arrow"></span>
    </div>
  </span>
  <div class="ne-control-group">
    <span class="ne-control">
      Color
      <span
        on:click="{toggleColorModal}"
        data-heap-color-control="{$store.textColor.hex.state}"
        data-test-color-control="{$store.textColor.hex.state}"
        class="ne-control-action ne-color-control"
        role="button">
        <Color hex={$store.textColor.hex.state} />
      </span>
    </span>
    <span class="ne-control">
      Align
      <span
        data-heap-alignment="{$store.format.state}"
        data-test-alignment="{$store.format.state}"
        class="ne-control-action"
        role="button"
        on:click={() => store.set($store.toggleFormat()) }>
        <svelte:component this={alignmentComponent} />
      </span>
    </span>
  </div>
</div>
<div class="ne-message">Your Message</div>

<textarea
  data-heap-message-box
  data-test-text-editor
  class="ne-textarea{overLineLimit ? ' ne-overlimit ne-too-big' : ''} {approachingLimit ? 'ne-near-limit' : ''} ne-align-{$store.format.state}"
  placeholder="Type a message"
  style="font-size: {fontSize}px; font-family: {fontFamily}; font-weight: {fontWeight}; color: {$store.textColor.hex.state}"
  on:input="{event => setText(event.target.value)}">{text}</textarea>
<div class="ne-sub">
  <span class="ne-inspiration" data-heap-message-picker-link role="button" on:click="{toggleMessageModal}">
    Need inspiration?
  </span>
  <span class="ne-line-counter {approachingLimit ? 'ne-near-limit-text' : ''} {overLimit ? 'ne-overlimit-text' : ''}">
      {linesRemaining}
        <span aria-hidden="true">/</span>
        <span class="sr-only">out of</span>
      {$store.lineLimit} printable lines remaining
  </span>
</div>

<style>
  .ne-line-counter {
    justify-self: flex-end;
    margin-bottom: 10px;
    font-weight: 400;
    font-size: 14px;
  }

  .ne-near-limit-text {
    color: #ff9014;
  }

  .ne-overlimit-text {
    color: #ce2333;
  }

  .ne-overlimit {
    border-color: #ce2333;
  }

  .ne-overlimit:focus {
    outline: #ce2333;
    outline-width: 2px;
    outline-style: auto;
  }

  .ne-near-limit {
    border-color: #ff9014;
  }

  .ne-near-limit:focus {
    outline:  #ff9014;
    outline-width: 2px;
    outline-style: auto;
  }

  .ne-text-controls {
    display: flex;
    justify-content: flex-start;
  }

  .ne-control {
    cursor: pointer;
    display: flex;
    flex-direction: column;
  }

  .ne-control-group {
    display: flex;
    flex-direction: row;
  }

  .ne-color-control {
    min-height: 32px;
    min-width: 32px;
  }

  .ne-control-action {
    display: flex;
  }

  .ne-align-left {
    text-align: left;
  }

  .ne-align-center {
    text-align: center;
  }

  .ne-sub {
    display: grid;
    width: 100%;
    grid-template-columns: auto auto;
    grid-template-rows: auto;
  }

  .ne-textarea {
    width: 100%;
    height: 186px;
    resize: none;
    overflow: auto;
    border: 1px solid #9c9c9c;
  }

  .ne-inspiration {
    cursor: pointer;
    text-decoration: underline;
    justify-self: start;
  }

  .ne-limit {
    justify-self: end;
  }

  .ne-font-control {
    flex-direction: row;
    align-items: center;
    padding: 10px;
    height: 100%;
    width: 320px;
    border-radius: 4px;
    border: solid 1px #8d939f; /* TODO: move font colors to constants*/
  }

  .ne-down-arrow {
    width: 0;
    height: 0;
    margin-left: auto;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;

    border-top: 5px solid black;
  }
</style>

<script>
  import Title from './Title.html';
  import Color from './Color.html';
  import PhotoInput from './PhotoInput.html';
  import AlignLeftIcon from './AlignLeftIcon.html';
  import AlignCenterIcon from './AlignCenterIcon.html';
  import { store } from '../stores';
  import { getDisplayName } from '../lib/font-utils';

  const alignmentComponents = {
    left: AlignLeftIcon,
    center: AlignCenterIcon
  }

  $: alignmentComponent = alignmentComponents[$store.format.state];
  $: linesRemaining = ($store.lineLimit - $store.numberOfLines) > 0 ? $store.lineLimit - $store.numberOfLines : 0;
  $: approachingLimit = $store.numberOfLines === $store.lineLimit || $store.numberOfLines === ($store.lineLimit - 1);
  $: overLimit = $store.numberOfLines > $store.lineLimit;

  export let overLineLimit;
  export let fontSize;
  export let fontFamily;
  export let fontWeight;
  export let text;
  export let setText;
  export let toggleMessageModal;

  function toggleColorModal() {
    store.set($store.showColorModal.toggle());
  }

  function toggleFontModal() {
    store.set($store.showFontModal.toggle());
  }
</script>
